import { render } from "./DynamicReport.vue?vue&type=template&id=24e6b338"
import script from "./DynamicReport.vue?vue&type=script&lang=js"
export * from "./DynamicReport.vue?vue&type=script&lang=js"

import "./DynamicReport.vue?vue&type=style&index=0&id=24e6b338&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__